'use client'

import { ArrowLeft24 } from '@vinted/monochrome-icons'
import { Button } from '@vinted/web-ui'
import { useNavigate } from 'react-router-dom'

import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { INBOX_URL } from '@marketplace-web/messaging/conversation-messaging-data'

const ConversationHeaderLeftAction = () => {
  const breakpoints = useBreakpoint()
  const navigate = useNavigate()

  if (!breakpoints.portables) return null

  return (
    <Button
      styling="flat"
      theme="amplified"
      inline
      iconName={ArrowLeft24}
      testId="back-button"
      onClick={() => navigate(INBOX_URL)}
    />
  )
}

export default ConversationHeaderLeftAction
